module.exports = __webpack_public_path__ + "img/ic-main-search.333e1149.svg";